import { castToBoolean } from '../../../../../lib/util';

class OpportunitiesPanelsController {
  constructor(
    $q,
    $scope,
    OpportunityInvitationService,
    LogService,
    APIService
  ) {
    "ngInject";
    this.$q = $q;
    this.$scope = $scope;
    this.OpportunityInvitationService = OpportunityInvitationService;
    this.LogService = LogService;
    this.APIService = APIService;

    // No panels expanded initially
    this._currentlyExpandedPanelIndex = -1;

    this._opportunities = [];
    this._opportunitiesByGroup = {};
  }

  set staffUser(staffUser) {
    this._staffUser = staffUser;
  }

  get staffUser() {
    return this._staffUser;
  }

  get opportunitiesByGroup() {
    return this.staffUser && this.staffUser.opportunityInvitationsByGroup || {};
  }

  get pendingOpportunities() {
    return this.opportunitiesByGroup.pending;
  }

  get interestedOpportunities() {
    return this.opportunitiesByGroup.interested;
  }

  get notInterestedOpportunities() {
    return this.opportunitiesByGroup.notInterested;
  }

  collapsedByIndex(idx) {
    return idx !== this._currentlyExpandedPanelIndex;
  }

  toggleCollapsedByIndex(idx) {
    if (this.collapsedByIndex(idx)) {
      // If this node is collapsed, expand it
      this._currentlyExpandedPanelIndex = idx;
    } else {
      // If this node is expanded, set expanded to -1 (no nodes expanded)
      this._currentlyExpandedPanelIndex = -1;
    }
  }
}

export default OpportunitiesPanelsController;
